import React, { useEffect } from "react"
import * as styles from "./zes-itinerary-search-block.module.scss"

const ODSEARCH_WIDGET_SCRIPT_SRC = "https://zou.maregionsud.fr/widget-external/web-widgets-external.js"
const ODSEARCH_CONTAINER_ID = "container__odsearch"
const ODSEARCH_READY_EVENT = "WidgetsExternal.ODSearchExternal.Ready"

type RenderProps = {
  locale?: string
}

// Content-page block: no DatoCMS model, shown when the page title matches (see type-page.tsx)
const ZesItinerarySearchBlock: React.FC<RenderProps> = ({ locale }) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return
    }

    // The widget notifies its own readiness instead of exposing an onload-safe global
    const onWidgetReady = (
      event: CustomEvent<{
        init: (containerId: string, options: { locale: string; isRedirectInNewTab: boolean }) => void
      }>
    ) => {
      event.detail.init(ODSEARCH_CONTAINER_ID, { locale: locale ?? "fr", isRedirectInNewTab: true })
    }
    document.addEventListener(ODSEARCH_READY_EVENT, onWidgetReady)

    const script = document.createElement("script")
    script.async = true
    script.defer = true
    script.src = ODSEARCH_WIDGET_SCRIPT_SRC
    document.getElementsByTagName("body")[0].appendChild(script)

    return () => {
      document.removeEventListener(ODSEARCH_READY_EVENT, onWidgetReady)
    }
  }, [locale])

  return (
    <section className={styles.block}>
      <div className={styles.widgetWrapper} id={ODSEARCH_CONTAINER_ID} />
    </section>
  )
}

export default ZesItinerarySearchBlock
